/**
 *
 */
export const unlock = {
    paths: [
        {
            d: 'M5.5 4v2h7A1.5 1.5 0 0 1 14 7.5v6a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5v-6A1.5 1.5 0 0 1 3.499 6H4V4a4 4 0 0 1 7.371-2.154.75.75 0 0 1-1.264.808A2.5 2.5 0 0 0 5.5 4Zm-2 3.5v6h9v-6h-9Z',
        },
    ],
    viewBox: '0 0 16 16',
};
//# sourceMappingURL=unlock.js.map